import React from 'react';
import { getGuideAccent } from './guidesUtils';

export function guideItemKind(item) {
  const type = item?.type;
  if (type === 'notebook') return 'notebook';
  if (type === 'article') return 'article';
  if (type === 'flashcard_deck' || type === 'deck') return 'deck';
  if (type === 'flashcard_set' || type === 'set') return 'set';
  return 'notebook';
}

export default function GuideItemIcon({ item, kind: kindProp }) {
  const kind = kindProp || guideItemKind(item);
  if (kind === 'notebook') {
    return (
      <span
        className="guides-notebook-book"
        style={{ '--notebook-color': getGuideAccent(`notebook-${item?.id}`) }}
        aria-hidden
      />
    );
  }
  if (kind === 'article') {
    return <i className="bi bi-file-earmark-text" aria-hidden />;
  }
  if (kind === 'deck') {
    return (
      <span className="guides-deck-glyph" aria-hidden>
        <span className="guides-deck-card guides-deck-card-back" />
        <span className="guides-deck-card guides-deck-card-front">
          <i className="bi bi-star-fill" />
        </span>
      </span>
    );
  }
  return <i className="bi bi-star" aria-hidden />;
}
